import { TreatmentPlanStatus } from '@principle-theorem/principle-core/interfaces';
import {
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
  IAvroSerialisedVersionedSchema,
} from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryNamedDocument,
  IBigQueryReffable,
  IBigQueryStatusHistory,
  ITimestampedDimension,
} from './common';

export interface ITreatmentPlanDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  name: string;
  steps: ISerialisedDocumentReference[];
  practitioner?: IBigQueryNamedDocument;
  status: TreatmentPlanStatus;
  statusHistory: IBigQueryStatusHistory<TreatmentPlanStatus>[];
  followUpHistory: IBigQueryFollowUp[];
  /**
   * TreatmentPlanType is an invalid avro enum
   */
  type: string;
  children: IBigQueryNamedDocument[];
  parent?: IBigQueryNamedDocument;
  config?: ISerialisedDocumentReference;
  template?: ISerialisedDocumentReference;
}

export interface IBigQueryFollowUp {
  uid: string;
  createFollowUp: boolean;
  followUpDate?: ISerialisedTimestamp;
  noFollowUpReason: IAvroSerialisedVersionedSchema;
  createdAt: ISerialisedTimestamp;
}
